const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'

declare global {
  interface Window {
    dataLayer: Array<Record<string, unknown>>
    gtag: (...args: unknown[]) => void
  }
}

export function initGA4(): void {
  if (typeof window === 'undefined') return
  if (document.getElementById('ga4-script')) return

  // Global dataLayer + gtag function
  window.dataLayer = window.dataLayer || []
  window.gtag = function (...args: unknown[]) {
    window.dataLayer.push(Object.fromEntries(args.map((a, i) => [i, a])))
  }
  window.gtag('js', new Date())
  window.gtag('config', GA_MEASUREMENT_ID)

  // Inject script tag (async, non-blocking)
  const script = document.createElement('script')
  script.id = 'ga4-script'
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)
}

export function trackEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>,
): void {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params)
  }
}

export function trackCtaClick(label: string): void {
  trackEvent('cta_click', { cta_label: label })
}

export function trackScrollDepth(percent: number): void {
  trackEvent('scroll_depth', { depth_percent: percent })
}
